import { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

export const tooltipStyles = {
  tooltip: {
    maxWidth: "230px",
    width: 'max-content',
    display: "inline-block",
    position: "relative",
    margin: "0",
    marginLeft: "0px !important",
    backgroundColor: "rgba(97, 97, 97, 0.92)",
    color: colorPalette.white.main,
    opacity: "1",
    transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 133ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    transform: "none",
    transformOrigin: "left center",
    borderRadius: "4px",
    padding: "4px 8px",
    fontSize: "14px",
    whiteSpace: "normal",
    overflowWrap: "normal",
    wordBreak: "normal",
    fontWeight: 400,
    fontFamily: "roboto-regular" // used to be "Roboto"
  },
  arrow: {
    position: "absolute",
    top: "0px",
    transform: "translate3d(0px, 8.8px, 0px)",
    left: "-10px",
    marginLeft: "-0.71em",
    height: "1em",
    width: "0.71em",
    overflow: "hidden",
    boxSizing: "border-box",
    color: "rgba(97, 97, 97, 0.9)",
    '::before': {
      transformOrigin: '100% 100%'
    }
  }
};
